export default __webpack_public_path__ + "static/media/crossIcon.e0b0b9b1.svg";